import {
    Box,
    CircularProgress,
    Divider,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import apiClient from '../../utils/apiClient';

const DispayReferalConfig = () => {
    const [referal, setReferal] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState('');
    const navigate = useNavigate();

    const getReferalConfig = async () => {
        try {
            setLoading(true);
            const response = await apiClient.get('/referralconfig/getreferral');

            if (response?.data?.status === true) {
                const config = response.data.config;
                const referalArray = Array.isArray(config) ? config : [config]; 
                setReferal(referalArray);
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || 'Error getting referral config');
        } finally {
            setLoading(false);
        }
    };

    const handleEditClick = (referal) => {
        // Navigate to edit page with referal data
        navigate('/create-edit-referal', { state: { referal } });
    }


    useEffect(() => {
        getReferalConfig();
    }, []);

    return (
        <Box sx={{ backgroundColor: '', padding: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h3">Referral</Typography>
            </Box>
            <Divider sx={{ marginBottom: 3 }} />

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                    <CircularProgress />
                </Box>
            ) : (
                <TableContainer component={Paper} elevation={1}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>Image</strong></TableCell>
                                <TableCell><strong>Description</strong></TableCell>
                                <TableCell><strong>Bonus Amount</strong></TableCell>
                                <TableCell><strong>Is Active</strong></TableCell>
                                <TableCell align="right"><strong>Actions</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {referal.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        No referal  found.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                referal.map((item) => (
                                    <TableRow key={item.id}>
                                        <TableCell>
                                            <img
                                                src={item.imageUrl}
                                                alt={item?.name || ' Image'}
                                                style={{ width: 70, height: 70, borderRadius: 5 }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {item?.description?.length > 50
                                                ? item.description.slice(0, 50) + '...'
                                                : item.description}
                                        </TableCell>
                                        <TableCell>{item.bonusAmount || '-'}</TableCell>
                                        <TableCell>{item?.isActive === true ? 'true' : 'false'}</TableCell>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                                                <IconButton onClick={() => handleEditClick(item)}>
                                                    <EditIcon />
                                                </IconButton>
                                                
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
            {errors && <Typography variant="body2" color="error">{errors}</Typography>}
        </Box>
    );
};

export default DispayReferalConfig;
